class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    const swiperEl = this.querySelector('swiper-container');
    if (!swiperEl) return;

    customElements.whenDefined('swiper-container').then(() => {
      swiperEl.initialize();

      const domSlideCount = swiperEl.querySelectorAll('swiper-slide').length;
      if (swiperEl.swiper && swiperEl.swiper.slides.length !== domSlideCount) {
        swiperEl.swiper.update();
      }
    });
  }
}

customElements.define('announcement-bar', AnnouncementBar);
